<script>
import Cart from '@/pages/projects/_id/-cart.vue'
import { projectCheckoutRoute } from '@/utils/projectRouting.js'

export default {
  name: 'ProjectsDetail',
  extends: Cart,
  watch: {
    cart: 'setDocumentTitle',
  },
  methods: {
    onSubmit() {
      this.$router.push(projectCheckoutRoute(this.id))
    },
    setDocumentTitle(item) {
      const title = item?.project?.label || this.id
      if (title) {
        this.$nextTick(() => {
          document.title = `${title} - Great American Art`
        })
      }
    },
  },
}
</script>
